import React from "react";
import { MdOutlineMoodBad } from "react-icons/md";

function NotFound(props) {
  return (
    <div className="bg-dark py-5 text-center rounded">
      <MdOutlineMoodBad size={60} />
      <p className="m-0">
        <em>{props.children}</em>
      </p>
    </div>
  );
}

export default NotFound;
